<template>
    <modal
        :saveAction="saveAction"
        :title="title"
        :id="id"
        :actionButtons="false"
        size="lg"
        :closeButton="true"
        @shown="shown()"
        :scrollable="true"
    >
        <template slot="modal-header"></template>

        <div class="row">
            <div class="col">
                <div class="card" data-toggle="lists">
                    <div class="card-header">
                        <div class="row align-items-center">
                            <div class="col">
                                <!-- Search -->
                                <div class="row align-items-center">
                                    <div class="col-auto pr-0">
                                        <span class="fe fe-x text-muted" v-if="query" @click="query=null"></span>
                                        <span class="fe fe-search text-muted" v-else></span>
                                    </div>
                                    <div class="col">
                                        <input
                                            type="search"
                                            v-model="query"
                                            class="form-control form-control-flush search no-glow"
                                            :placeholder="$t('Search')"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="col-auto"></div>
                            <div class="col-auto">
                                <div class="dropdown"></div>
                            </div>
                        </div>
                        <!-- / .row -->
                    </div>
                    <div class="card-body p-0 pl-4 pr-4" v-if="breadcrumbs.length>0">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li
                                    class="breadcrumb-item"
                                    v-for="(item, index) in breadcrumbs"
                                    :key="index"
                                    aria-current="page"
                                >
                                    <a
                                        href="#"
                                        v-if="parentId!=item._id"
                                        @click.prevent="parentId=item._id"
                                    >{{ item.label }}</a>
                                    <span v-else>{{ item.label }}</span>
                                </li>
                            </ol>
                        </nav>
                    </div>

                    <ul class="list-group list">
                        <li class="list-group-item" v-for="(item, index) in odb" :key="index">
                            <div class="row align-items-center">
                                <div class="col-auto">
                                    <button class="btn btn-sm btn-white ml-2" @click="use(item)">
                                        <i class="fe fe-check"></i>
                                    </button>
                                </div>
                                <div class="col-2">{{item.code}}</div>
                                <div class="col ml-n5">
                                    <span class="mb-1 name">{{item.label}}</span>
                                </div>
                                <div class="col-auto pointer">
                                    <button class="btn btn-sm ml-2" @click="parentId=item._id">
                                        <i class="fe fe-chevron-right h1 p-0 m-0"></i>
                                    </button>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import { modalMixins } from '@/mixins/modal.js'
import { mapActions, mapGetters, mapState } from 'vuex';
import { odbMixins } from '@/mixins/odb.js'


export default {
    name: 'odb-modal',
    props: ['id', 'saveAction', 'data', 'useAction'],
    mixins: [modalMixins, odbMixins],
    components: {
        Modal,
    },
    data() {
        return {
            query: null,
            breadcrumbs: [],
            parentId: null,
            model: {
                language: 'english'
            },
            title: 'ODB',
        }
    },
    methods: {
        use(item) {
            this.useAction(item);
            this.$toasted.global.success({ message: this.$t('Added successfully') });
        },
        getParents(parentId) {
            if (!parentId) return;
            this.get(parentId).then(item => {
                this.breadcrumbs.unshift(item);

                if (item.parentId) {
                    this.getParents(item.parentId);
                } else {
                    this.breadcrumbs.unshift({
                        label: 'Home',
                    });
                }
            });
        },
        shown() {
            /* Switch back to the first tab */
            this.query = null;
            this.queryItems();
        },
        validation(field) {
            if (this.errors && this.errors[field])
                return false
            else
                return null
        }
    },

}
</script>
<style>
.pre-formatted {
  white-space: pre;
}
</style>
